import { QueryClient } from '@tanstack/react-query'

/**
 * Egyetlen QueryClient-instance az egész admin alkalmazásra (DEC-FE-005).
 *
 * MVP defaults — azonosak a publik FE-vel (DEC-FE-013 stack-szimmetria):
 * - staleTime 30s — a help-requests / users / moderation_actions listák
 *   30 másodpercig stale-mentesek
 * - retry 1 — egyetlen retry minden GET-en, hogy ideiglenes network-glitch
 *   ne dobjon error-t
 * - refetchOnWindowFocus false — admin flow-on a focus-refetch zajos
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
